'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import { useRemainingTime } from './_hooks/useRemainingTime';
import { padNumber } from './_utils/padNumber';

/** 숫자 사이즈 동일하게 하려고 코드 문자 사용 */
const FONT_FAMILY = 'Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace';
interface BottomTimerProps {
  endDate: string | Date;
}
export const BottomTimer = t0 => {
  const $ = _c(35);
  const {
    endDate
  } = t0;
  let t1;
  if ($[0] !== endDate) {
    t1 = dayjs(endDate).endOf("day");
    $[0] = endDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const eventEndDate = t1;
  let t2;
  if ($[2] !== eventEndDate) {
    t2 = {
      endDate: eventEndDate
    };
    $[2] = eventEndDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    leftDays,
    leftHours,
    leftMinutes,
    leftSeconds,
    leftMilliseconds,
    isExpired
  } = useRemainingTime(t2);
  if (isExpired) {
    return null;
  }
  let t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="inline-flex min-h-30 items-center whitespace-nowrap rounded-r-pill bg-R-500 px-14 font-700 text-Gray-white typo-body4">마감까지</span>;
    t4 = cn("font-500 text-Gray-white");
    t5 = {
      fontFamily: FONT_FAMILY
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== leftDays) {
    t6 = <span style={t5}>{leftDays}</span>;
    $[7] = leftDays;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontFamily: FONT_FAMILY
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== leftHours) {
    t8 = padNumber(leftHours);
    $[10] = leftHours;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span style={t7}>{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      fontFamily: FONT_FAMILY
    };
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== leftMinutes) {
    t11 = padNumber(leftMinutes);
    $[15] = leftMinutes;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <span style={t10}>{t11}</span>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      fontFamily: FONT_FAMILY
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== leftSeconds) {
    t14 = padNumber(leftSeconds);
    $[20] = leftSeconds;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14) {
    t15 = <span style={t13}>{t14}</span>;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      fontFamily: FONT_FAMILY
    };
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  const t17 = Math.floor(leftMilliseconds / 10);
  let t18;
  if ($[25] !== t17) {
    t18 = padNumber(t17);
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18) {
    t19 = <span style={t16}>{t18}</span>;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t12 || $[30] !== t15 || $[31] !== t19 || $[32] !== t6 || $[33] !== t9) {
    t20 = <div className="sticky bottom-0 mt-auto gap-10 bg-Gray-black/60 p-12 flex-center">{t3}<p className={t4}>{t6}일{" "}{t9}시간{" "}{t12}분{" "}{t15}초{" "}{t19}</p></div>;
    $[29] = t12;
    $[30] = t15;
    $[31] = t19;
    $[32] = t6;
    $[33] = t9;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  return t20;
};